// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__WQTDL","primary":"Button_primary__JmVXF","secondary":"Button_secondary__4Emk1"};